module.exports = __webpack_public_path__ + "static/media/mensa_brands.938dd228.png";